import {useFormik} from 'formik';
import * as Yup from 'yup';
import {AxiosError} from 'axios';
import {useCategoryById} from '../../../entities';

interface UseMoveCategoryFormProps {
  setOpen: (open: boolean) => void;
  categoryId: string | null;
  initialGroupId?: string | null;
}

interface MoveFormValues {
  newGroupId: string;
}

export const useMoveCategoryForm = ({setOpen, categoryId, initialGroupId}: UseMoveCategoryFormProps) => {
  const {moveCategoryMutation} = useCategoryById(categoryId || '');

  const onSubmit = async (values: MoveFormValues) => {
    if (!categoryId || !values.newGroupId) return;
    try {
      await moveCategoryMutation.mutateAsync({
        categoryId,
        newGroupId: values.newGroupId,
      });
      setOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik<MoveFormValues>({
    initialValues: {
      newGroupId: initialGroupId || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      newGroupId: Yup.string().required('Выберите группу'),
    }),
    onSubmit,
  });

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    setFieldValue: formik.setFieldValue,
    setFieldTouched: formik.setFieldTouched,
    resetForm: formik.resetForm,
    submitForm: formik.submitForm,
    isLoading: moveCategoryMutation.isPending,
    submitError: moveCategoryMutation.error
      ? (moveCategoryMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
  };
};
